import { render, staticRenderFns } from "./wtBasePanel.component.vue?vue&type=template&id=7da14888&"
import script from "./wtBasePanel.component.vue?vue&type=script&lang=js&"
export * from "./wtBasePanel.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports